import { memo } from 'react';
import { ChartingSymbolQuoting } from '~/modules/SDK/chart4/components/ChartingSymbolQuoting';
export const StocksList = memo(function StocksList(props) {
    return (<div>
      {props.symbolStrings.map(symbolString => {
            return (<ChartingSymbolQuoting key={symbolString} symbol={symbolString} charting={props.charting}/>);
        })}
    </div>);
});
